import { Action } from '@ngrx/store';
import {TaxReturnAgreementParams } from '@model';

export enum AgreementActionTypes {
  CreateTaxReturnAgreement = '[CreateTaxReturnAgreement] create e-signature tax return agreement',
  CreateTaxReturnAgreementSuccess = '[CreateTaxReturnAgreement] create e-signature tax return agreement success',
  CreateTaxReturnAgreementFail = '[CreateTaxReturnAgreement] create e-signature tax return agreement fail',
  AgreementLinkLoad = '[MeteringPointAgreement] Link Load',
  AgreementLinkLoadSuccess = '[MeteringPointAgreement] Link Load Success',
  AgreementLinkLoadFail = '[MeteringPointAgreement] Link Load Fail'
}

export class CreateTaxReturnAgreement implements Action {
    readonly type = AgreementActionTypes.CreateTaxReturnAgreement;
    constructor(public payload: TaxReturnAgreementParams) {}
  }
  
  export class CreateTaxReturnAgreementSuccess implements Action {
    readonly type = AgreementActionTypes.CreateTaxReturnAgreementSuccess;
    constructor(public payload: number) {}
  }
  
  export class CreateTaxReturnAgreementFail implements Action {
    readonly type = AgreementActionTypes.CreateTaxReturnAgreementFail;
    constructor(public payload: any) {}
  }

export class AgreementLinkLoad implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoad;
    constructor(public agreementId: number) {}
}

export class AgreementLinkLoadSuccess implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoadSuccess;
    constructor(public payload: string) {}
}

export class AgreementLinkLoadFail implements Action {
    readonly type = AgreementActionTypes.AgreementLinkLoadFail;
    constructor(public payload: any) {}
}

export type AgreementActions = 
    | CreateTaxReturnAgreement
    | CreateTaxReturnAgreementSuccess
    | CreateTaxReturnAgreementFail
    | AgreementLinkLoad
    | AgreementLinkLoadSuccess
    | AgreementLinkLoadFail;
